import { render, staticRenderFns } from "./input-search.vue?vue&type=template&id=2b59e230&"
import script from "./input-search.vue?vue&type=script&lang=js&"
export * from "./input-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports